<div *ngIf="voucher" class="row m-0 align-items-center">
  <div class="col-6 voucher-title m-0 pl-0">
    <span>{{voucher.name}}</span>
  </div>
  <div class="col-6 text-right color-orange pr-0">
    <i class="color-orange fa fa-plus rotate-45 pointer fs-1" (click)="onClickRemoveVoucher($event)"></i>
    <!-- <button class="btn btn-link px-0"
            (click)="onClickRemoveVoucher($event)">{{ 'voucher.remove-voucher' | translate }}</button> -->
  </div>
</div>